"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//Fiona --add new file
const xhr_1 = __importDefault(require("./xhr"));
const AriForm_1 = require("../../AriForm");
const AriFormUtils = __importStar(require("../../utils/utils"));
const HEIC_MIME_TYPES = ['image/heic', 'image/heif'];
const HEIC_EXTENSION_REGEX = /\.(heic|heif)$/i;
const HEIC2ANY_PLUGIN_URL = '/cdn/heic2any.js';
let heic2AnyLoadPromise = null;
function isHeicFile(file) {
    return HEIC_MIME_TYPES.includes((file.type || '').toLowerCase()) || HEIC_EXTENSION_REGEX.test(file.name || '');
}
function getJpegFileName(fileName) {
    return HEIC_EXTENSION_REGEX.test(fileName)
        ? fileName.replace(HEIC_EXTENSION_REGEX, '.jpg')
        : `${fileName}.jpg`;
}
function createFileFromBlob(blob, fileName, originalFile) {
    try {
        return new File([blob], fileName, {
            type: 'image/jpeg',
            lastModified: originalFile.lastModified
        });
    }
    catch (err) {
        blob.name = fileName;
        blob.lastModified = originalFile.lastModified;
        return blob;
    }
}
function loadHeic2Any() {
    if (typeof window !== 'undefined' && typeof window.heic2any === 'function') {
        return Promise.resolve(window.heic2any);
    }
    if (!heic2AnyLoadPromise) {
        heic2AnyLoadPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = AriForm_1.AriForm.heic2anyUrl || HEIC2ANY_PLUGIN_URL;
            script.async = true;
            script.onload = () => {
                if (typeof window.heic2any === 'function') {
                    resolve(window.heic2any);
                    return;
                }
                reject(new Error('HEIC converter plugin did not initialize.'));
            };
            script.onerror = () => reject(new Error(`Unable to load HEIC converter plugin: ${script.src}`));
            document.head.appendChild(script);
        });
    }
    return heic2AnyLoadPromise;
}
function convertHeicToJpeg(file) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!isHeicFile(file)) {
            return file;
        }
        const heic2any = yield loadHeic2Any();
        const convertedBlob = yield heic2any({
            blob: file,
            toType: 'image/jpeg',
            quality: 0.9
        });
        const jpegBlob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;
        const jpegName = getJpegFileName(file.name || 'image.heic');
        return createFileFromBlob(jpegBlob, jpegName, file);
    });
}
/**
 * Azure File Services provider for file storage.
 * @param {object} ariform ariform instance
 * @returns {import('./typedefs').FileProvider} The FileProvider interface defined in index.js.
 */
function internalmedia() {
    return {
        uploadFile(file, fileName) {
            return __awaiter(this, void 0, void 0, function* () {
                const uploadFile = yield convertHeicToJpeg(file);
                const uploadFileName = uploadFile === file ? fileName : (fileName ? getJpegFileName(fileName) : uploadFile.name);
                const isConvertedFile = uploadFile !== file;
                const reader = new FileReader();
                return new Promise((resolve, reject) => {
                    reader.onload = (event) => {
                        const url = event.target.result;
                        resolve((() => __awaiter(this, void 0, void 0, function* () {
                            let rs = {
                                storage: 'internalmedia',
                                name: uploadFileName,
                                url: url,
                                size: uploadFile.size,
                                type: uploadFile.type,
                                originalName: isConvertedFile ? uploadFile.name : file.name,
                                sourceOriginalName: isConvertedFile ? file.name : undefined
                            };
                            let body = [];
                            body.push(rs);
                            // hungnq 
                            AriFormUtils.handleCAllAPI(`${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId}/${AriForm_1.AriForm.endpointUploadMediaDoc}`, 'POST', body, {}, (result) => {
                                Object.assign(rs, result[0]);
                            });
                            // end hungnq 
                            return rs;
                        }))());
                    };
                    reader.onerror = () => {
                        return reject(this);
                    };
                    reader.readAsDataURL(uploadFile);
                });
            });
        },
        downloadFile(file) {
            // const ariHeader = AriFormUtils.getVariable('clientInfo') ? AriFormUtils.getVariable('clientInfo') : AriFormUtils.getClientInfo();
            // const ariLang = AriFormUtils.getVariable('BlazorCulture') || 'en-US';
            // // return thẳng luôn Promise của makeStaticRequest
            // return AriForm.makeStaticRequest(`${AriForm.baseUrl}/${AriForm.serviceId}/${AriForm.endpointShowMediaDoc}/${XHR.trim(file.fileIdEncrypted)}`, 'GET', undefined, {
            //   headers: {
            //     'Content-type': 'application/json',
            //     'Authorization': AriFormUtils.getVariable('token'),
            //     'Ari-ClientInfo': ariHeader,
            //     'Ari-Lang': ariLang
            //   }
            // }).then(result => {
            //   console.log('download result', result);
            //   // Ở đây Formio đòi file info => mình phải trả đúng cấu trúc nó cần
            //   return {
            //     ...file,
            //     url: result
            //   };
            // }).catch(error => {
            //   console.error('Download failed', error);
            //   // Phải reject nếu lỗi
            //   return Promise.reject(new Error(`Failed to download file: ${error}`));
            // });
            return Promise.resolve(file);
        },
        deleteFile: function deleteFile(fileInfo) {
            // hungnq
            AriFormUtils.handleCAllAPI(`${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId}/${AriForm_1.AriForm.endpointDeleteMediaDoc}/${fileInfo.fileIdEncrypted}`, 'DELETE', fileInfo, {}, (result) => {
                return result;
            });
            // end hungnq
        }
    };
}
internalmedia.title = 'Internal Media';
exports.default = internalmedia;
